export default class util {
  public static bytesToString(data: DataView): string {
    let dataString = '';
    for (let i = 0; i < data.byteLength; i++) {
      dataString = dataString + String.fromCharCode(data.getUint8(i));
    }

    return dataString;
  }
}
